export default "/images/0c7e0cefc16ac3ead311232378e01993.avif";